import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

const Account = ({ formData, handleInputChange, validationErrors = {} }) => {
  return (
    <>
      <h2 className="mb-3">Account</h2>
      <Row className="g-3">
        <Col xs={12}>
          <Form.Group>
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              disabled
              isInvalid={!!validationErrors.email}
            />
            <Form.Control.Feedback type="invalid">
              {validationErrors.email}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col xs={12}>
          <Link
            to="/reset-password-authenticated"
            className="text-primary text-decoration-none"
          >
            Reset Password
          </Link>
        </Col>
      </Row>
    </>
  );
};

export default Account;
